// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__OqzoF","buttons":"SendReceipts_buttons__1OAp5","email":"SendReceipts_email__1rsgt","bookApptTitle":"SendReceipts_bookApptTitle__LqIUZ"};